/** @format */

import { useState } from 'react';

import { Link } from 'react-router-dom';

import ModalCustom from '../../../Shared/Components/ModalCustom';
import { error, success } from '../../../Shared/Components/Toast';
import useApi from '../../../Shared/hooks/api/Index';
import { useAccess } from '../../../Shared/hooks/useAccess';

const Status = ({
  matchId,
  statusId,
  statuses = [],
  roles = [],
  registerBy,
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalAccessRegisterIsOpen, setModalAccessRegisterIsOpen] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState();
  const [role, setRole] = useState();
  const { canManageMatches } = useAccess();

  const changeStatus = async () => {
    setLoading(true);
    await useApi.put(
      `/panel/match/${matchId}/status`,
      { status_id: status },
      (res) => {
        success('وضعیت مسابقه با موفقیت تغیر یافت');
        setLoading(false);
        setModalIsOpen(false);
      },
      (err) => {
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
        setLoading(false);
      },
    );
  };

  const changeAccessRegister = async () => {
    setLoading(true);
    await useApi.put(
      `/panel/match/${matchId}/access/register`,
      { register: role },
      (res) => {
        success('دسترسی ثبت نام با موفقیت تغیر یافت');
        setLoading(false);
        setModalAccessRegisterIsOpen(false);
      },
      (err) => {
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
        setLoading(false);
      },
    );
  };

  return (
    <>
      <aside className='w-100 rounded-1 overflow-hidden mt-1 p-2 py-2 bg-sky-light shadow-sm rounded-1'>
        <div className='bg-persian-green sidebar-header p-2 text-center'>
          <h1 className='text-dark-mode f-14 font-weight-bold'>تنظیمات</h1>
        </div>
        <ul className='d-flex flex-column nav border border-info p-2 '>
          {canManageMatches() && (
            <li
              className='border-bottom p-2 c-pointer'
              onClick={() => setModalIsOpen(true)}
            >
              وضعیت
            </li>
          )}
          {canManageMatches() && (
            <li
              className='border-bottom p-2 c-pointer'
              onClick={() => setModalAccessRegisterIsOpen(true)}
            >
              دسترسی ثبت نام
            </li>
          )}
          {canManageMatches() && (
            <li className='border-bottom p-2 c-pointer '>
              <Link className='text-dark' to={`/panel/matches/edit/${matchId}`}>
                ویرایش
              </Link>
            </li>
          )}
        </ul>
      </aside>

      <ModalCustom modalIsOpen={modalIsOpen}>
        <div className='d-flex flex-row border-bottom pb-2'>
          <i className='fad fa-warning f-20 mx-2'></i>
          <span className=''>تغیر وضعیت</span>
        </div>
        <div className='d-flex flex-column my-2'>
          <select
            defaultValue={statusId}
            className='form-control'
            onChange={(e) => {
              setStatus(e.target.value);
            }}
          >
            <option disabled selected={true}>
              وضعیت...
            </option>
            {statuses?.map((item) => (
              <option value={item.id}>{item.name_fa}</option>
            ))}
          </select>
        </div>
        <div className='d-flex flex-row justify-content-around my-3'>
          <button
            onClick={() => changeStatus()}
            className='btn btn-success w-48 f-13'
          >
            {loading ? (
              <div
                className='spinner-border spinner-border-sm text-white mb-1'
                role='status'
              ></div>
            ) : (
              'ذخیره'
            )}
          </button>
          <button
            onClick={() => setModalIsOpen(false)}
            className='btn btn-danger w-48 f-13'
          >
            لغو
          </button>
        </div>
      </ModalCustom>

      <ModalCustom modalIsOpen={modalAccessRegisterIsOpen}>
        <div className='d-flex flex-row border-bottom pb-2'>
          <i className='fad fa-warning f-20 mx-2'></i>
          <span className=''>دسترسی ثبت نام</span>
        </div>
        <div className='d-flex flex-column my-2'>
          <select
            defaultValue={registerBy}
            className='form-control'
            onChange={(e) => {
              setRole(e.target.value);
            }}
          >
            <option disabled selected={true}>
              دسترسی ثبت نام...
            </option>
            {roles?.map((item) => (
              <option value={item.id}>{item.description}</option>
            ))}
          </select>
        </div>
        <div className='d-flex flex-row justify-content-around my-3'>
          <button
            onClick={() => changeAccessRegister()}
            className='btn btn-success w-48 f-13'
          >
            {loading ? (
              <div
                className='spinner-border spinner-border-sm text-white mb-1'
                role='status'
              ></div>
            ) : (
              'ذخیره'
            )}
          </button>
          <button
            onClick={() => setModalAccessRegisterIsOpen(false)}
            className='btn btn-danger w-48 f-13'
          >
            لغو
          </button>
        </div>
      </ModalCustom>
    </>
  );
};

export default Status;
